export const CHECK_LOGIN = 'check_login';
export const VERIFY_ADMIN = 'VERIFY_ADMIN';
export const VERIFY_ADMIN_SUCCESS = 'VERIFY_ADMIN_SUCCESS';
export const VERIFY_ADMIN_FAIL = 'VERIFY_ADMIN_FAIL';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const REQUEST_OTP_USER = 'REQUEST_OTP_USER';
export const REQUEST_OTP_USER_SUCCESS = 'REQUEST_OTP_USER_SUCCESS';
export const REQUEST_OTP_USER_FAIL = 'REQUEST_OTP_USER_FAIL';

export const SWITCH_USER = 'SWITCH_USER';
export const SWITCH_USER_SUCCESS = 'SWITCH_USER_SUCCESS';
export const SWITCH_USER_FAIL = 'SWITCH_USER_FAIL';

export const API_ERROR = 'api_failed';

export const RESET_STATE = 'RESET_STATE';
export const RESET_ACTION_STATE = 'RESET_ACTION_STATE';
